import { Check } from "lucide-react";
import darklogo from "assets/images/bebrave-group-dark.svg";
import lightlogo from "assets/images/bebrave-group.svg";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme } from "components/core/theme-provider";
import { useWhiteLabelStore } from "state/store/white-label";

export default function SignupEmailSentPage() {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const { state } = useLocation();
  const { settings: whiteLabelSettings } = useWhiteLabelStore();

  // Determine which logo to use based on theme and white-label settings
  const logoSrc = theme === 'dark'
    ? (whiteLabelSettings?.logoUrlDarkMode || darklogo)
    : (whiteLabelSettings?.logoUrl || lightlogo);
  const email = state?.email;
  return <div className="flex min-h-screen flex-col items-center justify-center bg-background">
    <div className="mb-4 p-4 sm:mt-[-252px] w-60">
      <img src={logoSrc} className="w-full h-full object-contain" alt="logo" />
    </div>
    <Check className="text-[#17C964]" size={40} />
    <div className="mx-auto flex w-11/12 flex-col items-center gap-1 text-center sm:max-w-2xl">
      <h3 className="my-6 text-3xl font-bold tracking-tight">{t('EMAIL_SENT')}</h3>
      <p className="text-xl text-foreground">
        {t('EMAIL_SENT_TO')}{" "}
        <span className="font-semibold text-primary underline">{email}</span>. {t('PLEASE_FOLLOW_LINK')}
      </p>
    </div>
  </div>;
}
